import { useState, useCallback } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { clamp } from "@mui/x-data-grid/internals";

function useConfirm() {
  const [isOpen, setIsOpen] = useState(false);
  const [showIcon, setShowIcon]=useState(false);
  const [dialogOptions, setDialogOptions] = useState({
    title: "",
    content: "",
    onConfirm: null,
  });

  const openConfirmDialog = useCallback(
    (title, content, onConfirm, icon = null) => {
      setDialogOptions({ title, content, onConfirm });
      setIsOpen(true);
      setShowIcon(icon);
    },
    []
  );

  const closeDialog = () => {
    setIsOpen(false);
    setDialogOptions({ title: "", content: "", onConfirm: null });
  };

  const handleConfirm = () => {
    if (dialogOptions.onConfirm) dialogOptions.onConfirm();
    closeDialog();
  };

  const DialogComponent = () => (
    <Dialog open={isOpen}/*  onClose={closeDialog} */>
      <DialogTitle>{dialogOptions.title}</DialogTitle>
      <DialogContent>
        <Grid
          container
          display={"flex"}
          flexDirection={"row"}
          alignItems="center"
          justifyContent={"center"}
          spacing={1}
        >
          <Grid item>
            <WarningAmberIcon
              color="warning"
              fontSize="large"
              sx={{
                display: !showIcon ? "none" : "",
                width: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "6rem" },
                height: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "6rem" },
              }}
            />
          </Grid>
          <Grid ml={2} item>
            {dialogOptions.content}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          Oui
        </Button>
        <Button onClick={closeDialog} color="secondary">
          Non
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { openConfirmDialog, DialogComponent };
}

export default useConfirm;
